module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAAXNSR0IArs4c6QAAADNQTFRFAAAA////VVVVFhYtERctFBkuERYwERYtEhYuERYtEBUuEBYuERUtEBUuERUuEBYtEBUtKZV42QAAABB0Uk5TAAEDIi0yW2aAma2tv87w+O0gAzsAAADPSURBVFjD7ZbRDoMgDEUVBUQF7/9/7Z6MjrjRQU3Mcs8LUZuTtFRK1xFCCCF3YqyfCnhr5L4xQkAcxb4NIjah0UQghVLKIQFRlrUF0lAOGxJgRUIPBElcALxIOAGTZtzXwN65XlXoAKcqPH97lnCvnZpwr52acH/3PGFeu2ZhXrtmYS6isH5T8rW5bfJV7XCoOmDVR4D6kLoco8tSP0bVB73+VeTisrQCa8NlqaFFKMxG57EFMzAfT8f//BPuc8e4ZwjPKb9TmTIhhBDyZ7wABZIjOyzutIwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dp.png
// module id = HIff
// module chunks = 167